import Vue from "vue";
import Vue2Crumbs from "vue-2-crumbs";
import VueTheMask from "vue-the-mask";
import VTooltip from "v-tooltip";
import Clipboard from "v-clipboard";
import Toasted from "vue-toasted";
import VueYoutube from "vue-youtube";
import VueI18nUtils from "vue-i18n-utils";
import Vuelidate from "vuelidate";
import VueHead from "vue-head";
import VuePlyr from "vue-plyr";
import VueApexCharts from "vue-apexcharts";
import "moment/locale/uk";
import "moment/locale/ru";

Vue.use(VueApexCharts);

//use
Vue.use(Vuelidate);
Vue.use(VueHead);
Vue.use(VTooltip);
Vue.use(VuePlyr);
Vue.use(Vue2Crumbs);
Vue.use(VueYoutube);
Vue.use(VueI18nUtils);
Vue.use(Toasted, {
    duration: 5000,
});
Vue.use(VueTheMask);
Vue.use(Clipboard);
